/**
 * QA Console — ตัวช่วยเรื่องคะแนนฝั่งหน้าจอ
 *
 * ⚠️ Q10 — **ไม่มีการตัดสินผลในไฟล์นี้อีกแล้ว** · `resolveCaseStatus` กับ `resolvePriority`
 *    ถูกลบทิ้งพร้อมชั้นข้อมูลจำลองที่เป็นผู้เรียกรายสุดท้าย · ผลตัดสิน (pass/borderline/fail)
 *    และ priority ของเคสสอบสวน คำนวณฝั่ง server ด้วย `QaVerdict` ตัวเดียวแล้วส่งมาเป็น
 *    `qaStatus` / `priority` — สูตร C# นั้นรู้จัก auto-fail · rounding · pass mark ต่อช่องทาง
 *    ที่สูตร JS เดิมไม่รู้จัก
 *
 *    ถ้ามีใครเผลอเขียนสูตรที่สองกลับเข้ามาที่นี่ ผลตัดสินบนหน้าจอกับตัวกรอง SQL
 *    จะเถียงกันเองแบบที่ไล่หาสาเหตุยากมาก (ตัวเลขทั้งคู่ "ดูสมเหตุสมผล" ทั้งคู่)
 *
 * เหลือไว้เฉพาะเรื่องหน้าจอล้วน ๆ: ปัดเลข · เลือกสีตามระดับคะแนน · ฟอร์แมตเวลา
 */

/** ปัดคะแนนตาม rounding ที่ตั้งไว้ (0 = ไม่ปัด) */
export function applyRounding(score, rounding) {
  if (!rounding) return score;
  return Math.round(score / rounding) * rounding;
}

/** เคสนี้นับเป็น "ผ่าน" ไหม (borderline ยังถือว่าผ่าน) */
export function isPassing(status) {
  return status !== 'fail';
}

/**
 * สีคร่าว ๆ ตามระดับคะแนน — **heuristic สำหรับค่าเฉลี่ยรวม ไม่ใช่ผลตัดสินตาม policy**
 *
 * ⚠️ เกณฑ์ 85/80 ที่นี่ไม่ผูกกับ pass mark ที่ตั้งได้จากหน้า Settings · ใช้ได้เฉพาะกับ
 *    ตัวเลขที่ไม่มี verdict ของตัวเอง (ค่าเฉลี่ยของเจ้าหน้าที่) · แถวระดับเคสต้องส่ง
 *    `status` เข้า QaScoreCell แทน เพื่อให้สีตรงกับ chip ผลตัดสินในแถวเดียวกันเสมอ
 */
export function scoreColor(totalScore) {
  if (totalScore >= 85) return 'success';
  if (totalScore >= 80) return 'warning';
  return 'error';
}

/** สีของแถบคะแนนรายหัวข้อ (สัดส่วน 0–1) */
export function ratioColor(ratio) {
  if (ratio >= 0.85) return 'success';
  if (ratio >= 0.7) return 'warning';
  return 'error';
}

/** สรุปคะแนนรวมจาก parts */
export function sumParts(parts) {
  return parts.reduce((sum, part) => sum + part.earned, 0);
}

/** ฟอร์แมตวินาที → m:ss */
export function formatDuration(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
